import { useEffect, useMemo, useState } from 'react';

export function useLeadSelection(leadIds: Array<string | number>) {
  const normalized = useMemo(
    () => (leadIds || []).map(String).filter(Boolean),
    [leadIds]
  );

  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(normalized[0] ?? null);
  const [selectedLeadIds, setSelectedLeadIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (selectedLeadId && !normalized.includes(selectedLeadId)) setSelectedLeadId(null);
    setSelectedLeadIds(prev => new Set([...prev].filter(id => normalized.includes(id))));
  }, [normalized, selectedLeadId]);

  const toggleChecked = (id: string, checked: boolean) =>
    setSelectedLeadIds(prev => {
      const next = new Set(prev);
      checked ? next.add(id) : next.delete(id);
      return next;
    });

  const nextLead = () => {
    if (normalized.length === 0) return null;
    const idx = Math.max(0, normalized.findIndex(id => id === selectedLeadId));
    const nextIdx = idx >= 0 ? (idx + 1) % normalized.length : 0;
    return normalized[nextIdx];
  };

  return {
    normalized,
    selectedLeadId,
    setSelectedLeadId,
    selectedLeadIds,
    toggleChecked,
    nextLead,
  };
}